<template>
  <div class="container">
    <div class="page" v-if="pageStep===0">
      <page-game :page-step.sync="pageStep" :puzzle-id="totalPuzzleId" :org-id="totalOrgId" :pass-limit="puzzlePassLimit" :is-end="isEnd"></page-game>
    </div>
    <div class="page" v-if="pageStep===1">
      <page-draw :page-step.sync="pageStep" :activity-id="activityId" :org-id="totalOrgId"></page-draw>
    </div>
    <div class="page" v-if="pageStep===2">
      <page-rule :page-step.sync="pageStep"></page-rule>
    </div>
    <div class="page" v-if="pageStep===3">
      <page-rank :page-step.sync="pageStep" :puzzle-id="totalPuzzleId"></page-rank>
    </div>
    <div class="page" v-if="pageStep===4">
      <page-my :page-step.sync="pageStep" :activity-id="activityId"></page-my>
    </div>
    <div class="page" v-if="pageStep===5">
      <page-store :page-step.sync="pageStep"></page-store>
    </div>
    <div class="page" v-if="pageStep===7">
      <page-award :page-step.sync="pageStep" :activity-id="activityId"></page-award>
    </div>
  </div>
</template>
<script>
import pageAward from "./award.vue";
import pageGame from "./game.vue";
import pageDraw from "./draw.vue";
import pageRule from "./rule.vue";
import pageRank from "./rank.vue";
import pageStore from "./store.vue";
import pageMy from "./my.vue";
export default {
  components:{
    pageMy,
    pageAward,
    pageGame,
    pageDraw,
    pageRule,
    pageRank,
    pageStore,
  },
  data(){
    return {
      pageStep: '',// 页面路由
      apiToken: '',
      userInfo:{
        user_id: 0,
        nickname: '',
        avatar_url: '',
        has_mobile: 1
      },
      activityId: '' ,// 抽奖活动id
      puzzlePassLimit: 60000 ,// 拼图活动通关条件
      totalOrgId: 0,// 来源门店id
      totalPuzzleId: 0,// 统计id
      isEnd: false,// 活动是否结束
    };
  },
  created(){
    // 记录来源
    let query = this.$route.query;
    this.totalOrgId = query.oid||0;
    this.totalPuzzleId = query.pid||0;
    // 判断活动是否过期
    this.$ajax({
      headers: {
        "X-DEVICE-TYPE": "4",
        "X-APP-NAME": "musicwow",
        "Content-Type": "application/json",
      },
      url: process.env.VUE_APP_CONT_API + `api/v1/six_year/puzzle/config?puzzle_id=${query.pid||0}`,
      method: "get",
    }).then((res) => {
      if (res.data.error_code === 0) {
        this.activityId = res.data.data.activity_id;
        this.puzzlePassLimit = res.data.data.pass_score;
        if(res.data.data.is_end){
          // this.$toast('活动已结束');
          this.isEnd = true;
        }
      }else{
        this.$toast(res.data.message);
      }
    });
    // 登录
    this.wxLogin();
  },
  methods:{
    wxLogin(){
      // 检查localstorage有没有token
      let tokenCache = localStorage.getItem('mobile_musicwow_app_wx_token');
      if(tokenCache){
        // 有，进入游戏页
        this.apiToken = tokenCache;
        this.pageStep = 0;
      }else{
        // 判断有无微信回调code
        let query = this.$route.query;
        let code = query.code;
        let oid = query.oid || 0;// 来源门店id
        let pid = query.pid || 0;// 统计id，0无，1测试，2运营，3正式
        if(code){
          // 有，已经授权，调用APP登录接口
          this.$ajax({
            headers: {
              "X-DEVICE-TYPE": "4",
              "X-APP-NAME": "musicwow",
              "Content-Type": "application/json",
            },
            url: process.env.VUE_APP_CONT_API + "api/v1/account/auth_login",
            method: "post",
            data:{
              type:2,
              app_id:'wx4d3ccd23d6464806',
              code: code,
            }
          }).then((res) => {
            if (res.data.error_code === 0) {
              this.apiToken = res.data.data.token;
              this.userInfo = res.data.data.user;
              localStorage.setItem('mobile_musicwow_app_wx_token',res.data.data.token);
              localStorage.setItem('mobile_musicwow_app_wx_user',JSON.stringify(res.data.data.user));
              location.href = location.origin + `/#/activity/puzzle?oid=${oid}&pid=${pid}`;
              location.reload();
            }else{
              this.$toast(res.data.message);
            }
          });
        }else{
          // 无，跳转授权
          let url = location.origin;
          location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx4d3ccd23d6464806&redirect_uri=${encodeURIComponent(url)}&response_type=code&scope=snsapi_userinfo&state=wx_login_activity_puzzle_pid_${pid}_oid_${oid}#wechat_redirect`;
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.container{
  height: 100vh;
}
.page{
  height: 100%;
  overflow: hidden auto;
}
</style>